<app-fire-content-block [id]="contentBlock" [data-automation-id]="contentBlock">
</app-fire-content-block>
